import { describeError } from "../api/errors";

/**
 * Every failure the user sees carries the correlation id.
 *
 * §16.5 gives each request an id and logs it; showing it here is what turns
 * "it didn't work" into a report an operator can actually trace. It costs one
 * line and saves the round trip that would otherwise be needed to find out
 * which request failed.
 */
export function ErrorBanner({ error, onDismiss }: { error: unknown; onDismiss?: () => void }): JSX.Element | null {
  if (error === undefined || error === null) return null;
  const described = describeError(error);
  return (
    <div className="banner banner-error" role="alert">
      <div>
        <strong>{described.title}</strong>
        <p>{described.detail}</p>
        {described.requestId && <p className="request-id">Request {described.requestId}</p>}
      </div>
      {onDismiss && <button type="button" className="ghost" onClick={onDismiss}>Dismiss</button>}
    </div>
  );
}
